import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import Header from "../PackageInfo/Header";
// import a1 from "../../Images/Adrai/a6.jpg";
import a2 from "../../Images/Adrai/a2.jpg";
import a3 from "../../Images/Adrai/a3.JPG";
import a4 from "../../Images/Adrai/a4.JPG";
import a5 from "../../Images/Adrai/a5.jpg";
import a6 from "../../Images/Adrai/a6.jpg";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";

const data = [
  {
    day: "Day 1",
    subheading: "Adrai Jungle + Kalu Waterfall Viewpoint",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:15 AM", activity: "Pick-up at Swargate." },
      { time: "05:25 AM", activity: "Pick-up at Chhatrapati Shivaji Nagar." },
      { time: "05:45 AM", activity: "Pick-up at Nashik Phata." },
      { time: "07:30 AM", activity: "En-route breakfast." },
      {
        time: "09:00 AM",
        activity: "Arrive at base village and trek briefing.",
      },
      { time: "09:30 AM", activity: "Begin the scenic Adrai Jungle trek." },
      {
        time: "11:30 AM",
        activity: "Reach Kalu Waterfall viewpoint for a group meetup.",
      },
      {
        time: "12:30 PM",
        activity: "Arrive at Adrai Waterfall and soak in the natural beauty.",
      },
      {
        time: "02:00 PM",
        activity: "Start the return trek back towards the base village.",
      },
      {
        time: "04:00 PM",
        activity: "Lunch at a homestay with scenic Sahyadri views.",
      },
      { time: "05:00 PM", activity: "Begin the return journey to Pune." },
      { time: "10:00 PM", activity: "Approx. arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: ["Food at Adrai Waterfall is at your own cost during free time."],
    inclusions: [
      "🚌 Transport Pune to Pune by NON-AC bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌲 Forest Entry Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Any personal insurance or medical expenses beyond basic first aid.",
      "Items of personal nature or additional equipment not listed.",
    ],
    verticalCards: [
      // { title: "Adrai Trail", image: a1 },
      { title: "Green Forest", image: a2 },
      { title: "Waterfall View", image: a3 },
      { title: "River Walk", image: a4 },
      { title: "Monsoon Vibe", image: a5 },
      // { title: "Monsoon Vibe", image: a5 },
      { title: "Waterfall View", image: a6 },
    ],
    trekData: [
      {
        name: "Adrai Jungle Trek",
        image: a6,
        info: "Join us for a thrilling trek through the mystical forests of Adrai and the Kalu Waterfall viewpoint — a perfect monsoon escape filled with nature, greenery, and good vibes! 🌧️🌿 Approx. 7 km one way on a simple and scenic straight trail that is not too hectic.",
      },
    ],
    faq: [
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes. The trail is simple, scenic, and beginner friendly, making it ideal for a monsoon day trek.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rain gear, comfortable and sturdy trekking shoes, sunscreen, a camera, and any personal medicines. For a complete list and more detailed packing suggestions, please check our “Things to Carry” section.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by NON-AC bus is included in the package.",
      },
      {
        question: "Can I buy food at the waterfall?",
        answer:
          "Yes, there is free time at Adrai Waterfall where you can buy food or snacks at your own cost.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, an experienced trek lead and local guide will accompany the group throughout the trek.",
      },
    ],
  },
];

const AdraiJungle = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="adrai Jungle"
          location="Malshej Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
      </div>
      <PackageInclusions />
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default AdraiJungle;
